import React from 'react'
import {Link} from "react-router-dom";
function Not_Found() {
  return (
    <div className='my-5 pt-2'>
      <div className='pt-5  text-center mt-5'>
      <h1 className='display-2'>404 - Not Found!</h1>
      <p className='fs-5 pb-3'>Sorry, the page you are looking for does not exist.</p>
      <Link to='/'><button className='px-5 pt-1 pb-2 bg-dark text-white border rounded'>Home Page</button></Link>
      </div>
    </div>
  )
}

export default Not_Found
